// src/features/records/components/GalleryView/components/EmptyState.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image } from 'lucide-react';
import styles from './EmptyState.module.css';

const EmptyState = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.emptyState}>
      <Image size={64} strokeWidth={1.5} className={styles.icon} />
      <h3 className={styles.title}>{t('records.views.gallery.empty.title')}</h3>
      <p className={styles.description}>
        {t('records.views.gallery.empty.description')}
      </p>
    </div>
  );
};

export default EmptyState;
